module.exports = __webpack_public_path__ + "static/lighting-table-cell-highlight2-20dc8c3fec019f8b1db5bcf5e8dcc684.png";